export default {
  workbench: "工作台",
  taskCenter: "任务中心",
  messageNotification: "消息提醒",
  supplierManagement: "供应商管理",
  supplierProfileManagement: "供应商档案管理",
  emailInvite: "邮箱邀请",
  supplierProfileDetail: "供应商档案详情",
  supplierPerformanceManagement: "供应商绩效管理",
  assessmentTemplateManagement: "评估模板管理",
  admissionAssessmentTemplate: "准入评估模板",
  performanceAssessmentTemplate: "绩效考核模板",
  addTemplate: "添加模版",
  supplierExceptionManagement: "供应商异常管理",
  supplierRiskLevel: "供应商风险登记",
  materialException: "物料异常登记",
  supplierVisitAuditManagement: "供应商拜访与审计管理",
  visitManagement: "拜访管理",
  auditManagement: "审计管理",
  requirementManagement: "需求管理",
  sourcingApplicationManagement: "寻源申请管理",
  purchaseApplicationManagement: "采购申请管理",
  priceInquiryManagement: "询比价管理",
  priceCompareDetail: "询比价详情",
  contractManagement: "合同管理",
  purchaseOrderManagement: "采购订单管理",
  systemSettings: "系统设置",
  changePassword: "修改密码",
  orderDetail: "订单详情",
};
